import React from 'react';
import type { MotorAd } from '../../types';
import { PrimaryTag } from './PrimaryTag';

type LegendaryMotorPrimaryTagProps = {
    ad: MotorAd;
    className?: string;
};

export function LegendaryMotorPrimaryTag(props: LegendaryMotorPrimaryTagProps) {
    const { ad, className } = props;

    const isSold = ad.flags.includes('sold');
    const smidigBilhandelLabel = ad.labels?.find(
        (label) => label.id === 'smidig_bilhandel',
    );

    return (
        <>
            {!isSold && smidigBilhandelLabel && (
                <PrimaryTag className={className} type="positive">
                    {smidigBilhandelLabel.text}
                </PrimaryTag>
            )}
        </>
    );
}
